<template>
    <v-layout row wrap class="third-party-login my-0">
        <v-flex xs4 class="pt-0" :class="{'pr-0': thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown}">
            <component
                :is="facebookLoginButtonComponent"
                v-if="facebookLoginButtonComponent"
                @error="$emit('error')"
                @authenticated="$emit('authenticated')"
                :hide-text="thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown"
                :size="$vuetify.breakpoint.mdAndUp ? 12 : 20"
            >
                Facebook
            </component>
        </v-flex>

        <v-flex xs4 class="pt-0" :class="{'px-1': thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown}">
            <component
                :is="googleLoginButtonComponent"
                v-if="googleLoginButtonComponent"
                @error="$emit('error')"
                @authenticated="$emit('authenticated')"
                :hide-text="thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown"
                :size="$vuetify.breakpoint.mdAndUp ? 12 : 27"
            >
                Google
            </component>
        </v-flex>

        <v-flex xs4 class="pt-0" :class="{'pl-0': thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown}">
            <component
                :is="appleLoginButtonComponent"
                v-if="appleLoginButtonComponent"
                @error="$emit('error')"
                @authenticated="$emit('authenticated')"
                :hide-text="thirdPartyLoginButtonsIconsOnly || $vuetify.breakpoint.smAndDown"
                :size="$vuetify.breakpoint.mdAndUp ? 15 : 27"
            >
                Apple
            </component>
        </v-flex>
    </v-layout>
</template>

<style>
.third-party-login .v-btn--large {
    padding: 0 16px;
}
</style>

<script>
import Vue from 'vue';

export default {
    name: 'ThirdPartyLoginButtons',
    props: {
        thirdPartyLoginButtonsIconsOnly: Boolean,
    },
    computed: {
        facebookLoginButtonComponent() {
            return Vue.options.components['facebook-login-button'];
        },
        googleLoginButtonComponent() {
            return Vue.options.components['google-login-button'];
        },
        appleLoginButtonComponent() {
            return Vue.options.components['apple-login-button'];
        },
    },
};
</script>